import React, { useState } from "react";
import {
    Mail,
    Phone,
    MessageCircle,
    MapPin,
    ShieldCheck,
    PackageCheck,
    Truck,
    RotateCcw,
    ChevronDown,
    HelpCircle,
} from "lucide-react";

const faqs = [
    {
        q: "How long does shipping usually take?",
        a: "Orders are usually processed within 1–2 business days. Delivery time depends on your location and selected shipping option.",
    },
    {
        q: "Can I return or exchange products?",
        a: "Returns or exchanges are accepted only as per the return policy mentioned in the Terms & Conditions. Items should be unused and in original condition.",
    },
    {
        q: "How can I track my order?",
        a: "You can track your order from your account order section once the order is shipped.",
    },
    {
        q: "What should I do if I receive a damaged item?",
        a: "Please contact us as soon as possible with your order details and product photos so our team can help you.",
    },
    {
        q: "Do you support bulk or custom bead orders?",
        a: "Yes, for bulk or custom requirements, please contact us through WhatsApp or email.",
    },
];

const ContactUs = () => {
    const [openFaq, setOpenFaq] = useState<number | null>(0);

    const contactCards = [
        {
            icon: <Mail size={28} />,
            title: "Email Us",
            value: "contact@priyabeads.com",
            note: "We usually reply within 24 hours",
        },
        {
            icon: <Phone size={28} />,
            title: "Call Us",
            value: "+91 72330 34085",
            note: "Mon - Sat, 10:00 AM - 6:00 PM IST",
        },
        {
            icon: <MessageCircle size={28} />,
            title: "WhatsApp Us",
            value: "+91 72330 34085",
            note: "Quick support for orders and queries",
        },
        {
            icon: <MapPin size={28} />,
            title: "Our Office",
            value: "PriyaBeads",
            note: "C 15/392 Lallapura, Matakund, Varanasi, Uttar Pradesh",
        },
    ];

    return (
        <div className="bg-white text-gray-900">
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
                {/* <div className="mb-8">
                    <h1 className="text-3xl md:text-4xl font-bold">About Us & Contact Us</h1>
                </div> */}

                {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 rounded-3xl border border-gray-200 p-5 md:p-8 shadow-sm">
          <div className="min-h-[260px] rounded-2xl bg-gradient-to-br from-[#e8f7f4] to-white border border-gray-200 flex items-center justify-center">
            <img
              src="/logo.png"
              alt="PriyaBeads"
              className="max-h-44 object-contain opacity-90"
            />
          </div>

          <div className="flex flex-col justify-center">
            <h2 className="text-2xl font-bold mb-4">About PriyaBeads</h2>
            <p className="text-gray-700 leading-7 mb-3">
              PriyaBeads was born out of a passion for creativity and crafting.
              We offer beads, charms, findings, jewellery supplies and craft
              essentials for makers across India.
            </p>
            <p className="text-gray-700 leading-7">
              Our mission is to provide beautiful products, fair prices and
              helpful service so you can create something special.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
              {[
                { icon: <PackageCheck />, text: "Quality Products" },
                { icon: <ShieldCheck />, text: "Secure Shopping" },
                { icon: <Truck />, text: "Reliable Delivery" },
                { icon: <RotateCcw />, text: "Easy Support" },
              ].map((item) => (
                <div key={item.text} className="text-center">
                  <div className="mx-auto mb-2 h-11 w-11 rounded-full bg-[#e8f7f4] text-[#00927c] flex items-center justify-center">
                    {React.cloneElement(item.icon, { size: 22 })}
                  </div>
                  <p className="text-sm font-semibold">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div> */}

                <div>
                    <div className="relative min-h-[320px] overflow-hidden rounded-3xl border border-gray-200">

                        <img
                            src="/background.png"
                            alt="Craft Background"
                            className="absolute inset-0 h-full w-full object-cover"
                        />

                        <div className="absolute inset-0 bg-white/20"></div>

                        <div className="relative z-10 flex h-full min-h-[320px] flex-col items-center justify-center px-6 text-center">

                            <div className="p-2">
                                <img
                                    src="/logo.png"
                                    alt="PriyaBeads"
                                    className="h-28 md:h-36 object-contain mx-auto drop-shadow-lg"
                                />
                            </div>

                            <h3 className="mt-6 text-2xl md:text-3xl font-bold text-gray-900">
                                Create Something Beautiful
                            </h3>

                            <p className="mt-3 max-w-md text-sm md:text-base text-gray-700 leading-7">
                                Discover premium beads, charms, jewellery supplies and craft essentials
                                designed for creators across India.
                            </p>
                        </div>
                    </div>

                </div>

                <div className="text-center mt-14 mb-8">
                    <h2 className="text-2xl font-bold">Get in touch</h2>
                    <p className="text-gray-600 mt-2">
                        We’re here to help with questions, support or feedback.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {contactCards.map((card) => (
                        <div
                            key={card.title}
                            className="rounded-2xl border border-gray-200 p-6 text-center shadow-sm hover:shadow-md transition"
                        >
                            <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-[#e8f7f4] text-[#00927c] flex items-center justify-center">
                                {card.icon}
                            </div>
                            <h3 className="font-bold mb-2">{card.title}</h3>
                            <p className="font-semibold text-gray-900">{card.value}</p>
                            <p className="text-sm text-gray-600 mt-2">{card.note}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-14 rounded-3xl border border-gray-200 shadow-sm overflow-hidden">
                    <div className="p-5 md:p-6 border-b border-gray-200 flex items-center gap-3">
                        <HelpCircle className="text-[#00927c]" />
                        <h2 className="text-xl md:text-2xl font-bold">
                            Frequently Asked Questions
                        </h2>
                    </div>

                    <div>
                        {faqs.map((faq, index) => (
                            <div key={faq.q} className="border-b border-gray-200 last:border-b-0">
                                <button
                                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                                    className="w-full px-5 md:px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50"
                                >
                                    <span className="font-semibold">{faq.q}</span>
                                    <ChevronDown
                                        size={20}
                                        className={`transition ${openFaq === index ? "rotate-180 text-[#00927c]" : ""
                                            }`}
                                    />
                                </button>

                                {openFaq === index && (
                                    <p className="px-5 md:px-6 pb-5 text-gray-600 leading-7">
                                        {faq.a}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactUs;